import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Sidebar from '../common/Sidebar';
import Header from '../common/Header';
import clsx from 'clsx';
import LayoutMain from './LayoutMain';
import { PostViewerProvider } from '../postViewer/PostViewerProvider';
import { useActingTenantTabSync } from '@/hooks/useActingTenantTabSync';

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  useActingTenantTabSync();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar */}
        <AnimatePresence mode="wait">
          {sidebarOpen && (
            <motion.div
              initial={{ x: -300, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -300, opacity: 0 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
              className="fixed inset-y-0 left-0 z-50 w-64 lg:static lg:inset-0"
            >
              <Sidebar onToggle={toggleSidebar} />
            </motion.div>
          )}
        </AnimatePresence>

        {/* Main content */}
        <div
          className={clsx(
            'flex-1 flex flex-col overflow-hidden transition-all duration-300',
            sidebarOpen ? 'lg:ml-0' : 'ml-0'
          )}
        >
          {/* Header */}
          <Header onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />

          {/* Las publicaciones de redes se abren en un visor in-app, no en otra pestaña. */}
          <PostViewerProvider>
            <LayoutMain />
          </PostViewerProvider>
        </div>
      </div>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={toggleSidebar}
        />
      )}
    </div>
  );
};

export default Layout;
